/**
 * All query keys used by react-query.
 */
export const QueryKeys = {
  LOGIN_APP_INSTANCE_LIST: 'LOGIN_APP_INSTANCE_LIST',
  LOGIN_APP_SESSION_INFO: 'LOGIN_APP_SESSION_INFO',
  LOGIN_APP_OXS_TERMS: 'LOGIN_APP_OXS_TERMS',
} as const;
